module.exports = __webpack_public_path__ + "static/media/signOut.bf74d7f2.svg";